import { PlatformSiteAri } from '@atlassian/ari';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PAGE_SIZE, OBJECT_TYPES } from './recentQueryConfig.ts';
import { RecentContentMenuQuery } from './queries/RecentContentMenuQuery.graphql.ts';

export function preloadRecentContentMenu(cloudId) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: RecentContentMenuQuery,
		variables: {
			cloudId: PlatformSiteAri.create({ siteId: cloudId }).toString(),
			after: '',
			first: PAGE_SIZE,
			eventTypes: [],
			objectTypes: OBJECT_TYPES,
		},
		fetchPolicy: 'network-only',
	});
}
